module.exports = __webpack_public_path__ + "static/media/namdia.594c27df.png";